import Slider from "react-slick";
import Header from '../components/header';
import Footer from '../components/footer';
import ContactModal from '../components/contact-modal';

function Legal() {



  return (
      <>
      <div className="main-page-wrapper font-gordita">
        {/* Header */}
        <Header />
        
        {/* Page Title */}
        {/* <div className="fancy-hero-one">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-11 m-auto">
                <div className="page-title text-center">
                  <h1>Legal Documentation</h1>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Terms and Policy Section */}
        <div className="terms_and_policy  mb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a className="nav-link active" data-toggle="tab" href="#opt1">1. Service Terms of Use</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#opt2">2. Data Processing Agreement</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#opt3">3. Privacy Policy</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#opt4">4. Data Security</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#opt5">5. API Usage Terms</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#opt6">6. Compliance & Regulations</a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-8">
                {/* Tab panes */}
                <div className="tab-content">
                  <div id="opt1" className="tab-pane fade active show">
                    <h2 className="font-gilroy-bold">Service Terms of Use</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. Introduction</h3>
                    <p>These Terms of Use govern your use of Cybernate's AI analytics services and platforms, which include our real-time video analytics, sensor data intelligence, and AI-powered systems (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms.</p>
                    
                    <h3>2. Service Description</h3>
                    <p>Cybernate provides AI-powered analytics for video streams, sensors, and other data sources. Our Services may include, but are not limited to:</p>
                    <ul>
                      <li>Real-time video stream analysis</li>
                      <li>Object detection and recognition</li>
                      <li>Sensor data processing and anomaly detection</li>
                      <li>Custom API solutions for enterprise integration</li>
                      <li>Cloud-based and on-premises deployment options</li>
                    </ul>
                    
                    <h3>3. Acceptable Use</h3>
                    <p>You agree to use the Services only for lawful purposes and in accordance with these Terms. You agree not to use the Services:</p>
                    <ul>
                      <li>In any way that violates applicable local, national, or international law or regulation</li>
                      <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors</li>
                      <li>To violate the privacy rights of individuals</li>
                      <li>To engage in surveillance activities outside the bounds of legal consent</li>
                      <li>To transmit or upload any material that contains viruses, trojan horses, or other harmful code</li>
                    </ul>
                    
                    <h3>4. Service Modifications</h3>
                    <p>Cybernate reserves the right to modify, suspend, or discontinue any part of the Services at any time. We will provide reasonable notice of any significant changes that may affect your use of the Services.</p>
                  </div>
                  
                  <div id="opt2" className="tab-pane fade">
                    <h2 className="font-gilroy-bold">Data Processing Agreement</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. Data Controller and Processor Relationship</h3>
                    <p>When you use Cybernate's Services for analyzing your data streams, you are the "data controller" of all data processed through our systems. Cybernate acts as a "data processor," which means we will only process your data as required to provide our Services and in accordance with your instructions.</p>
                    
                    <h3>2. Processing Activities</h3>
                    <p>Cybernate may process the following types of data in providing the Services:</p>
                    <ul>
                      <li>Video stream content and metadata</li>
                      <li>Sensor readings and telemetry data</li>
                      <li>Derived analytics and insights from your data</li>
                      <li>Configuration settings and preferences</li>
                    </ul>
                    
                    <h3>3. Data Retention</h3>
                    <p>We will retain your data only for as long as necessary to provide the Services or as required by applicable law. You can request deletion of your data at any time, and we will comply with such requests within 30 days unless retention is required by law.</p>
                    
                    <h3>4. Subprocessors</h3>
                    <p>Cybernate may use a limited number of third-party service providers to help deliver our Services. All subprocessors are bound by data protection terms that comply with applicable regulations. A current list of subprocessors is available upon request.</p>
                  </div>
                  
                  <div id="opt3" className="tab-pane fade">
                    <h2 className="font-gilroy-bold">Privacy Policy</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. Information We Collect</h3>
                    <p>Cybernate collects several types of information to provide and improve our Services:</p>
                    <ul>
                      <li><strong>Account Information:</strong> Email addresses, names, and contact details of users who register for our Services</li>
                      <li><strong>Usage Data:</strong> Information about how you use our Services, including API calls, feature usage, and performance metrics</li>
                      <li><strong>Customer Content:</strong> The data streams you process through our Services, such as video feeds and sensor data</li>
                      <li><strong>Device Information:</strong> Information about the devices used to access our Services</li>
                    </ul>
                    
                    <h3>2. How We Use Your Information</h3>
                    <p>We use the information we collect to:</p>
                    <ul>
                      <li>Provide, maintain, and improve our Services</li>
                      <li>Process and complete transactions</li>
                      <li>Send technical notices and support messages</li>
                      <li>Monitor and analyze trends, usage, and activities in connection with our Services</li>
                      <li>Enhance the security and safety of our Services</li>
                    </ul>
                    
                    <h3>3. Data Security</h3>
                    <p>Cybernate takes data security seriously. We implement industry-standard technical and organizational measures to protect your data, including encryption, access controls, and regular security assessments. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security.</p>
                    
                    <h3>4. Your Rights</h3>
                    <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
                    <ul>
                      <li>The right to access your personal information</li>
                      <li>The right to correct inaccurate information</li>
                      <li>The right to delete your personal information</li>
                      <li>The right to restrict or object to processing</li>
                      <li>The right to data portability</li>
                    </ul>
                    <p>To exercise these rights, please contact us at <a href="mailto:support@cybernate.ai">support@cybernate.ai</a>.</p>
                  </div>
                  
                  <div id="opt4" className="tab-pane fade">
                    <h2 className="font-gilroy-bold">Data Security</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. Security Infrastructure</h3>
                    <p>Cybernate's security infrastructure is designed with multiple layers of protection:</p>
                    <ul>
                      <li><strong>Physical Security:</strong> Our cloud environments are hosted in data centers that are SOC 2 and ISO 27001 certified</li>
                      <li><strong>Network Security:</strong> We implement firewalls, intrusion detection systems, and regular vulnerability scanning</li>
                      <li><strong>Data Encryption:</strong> All data is encrypted both in transit and at rest using industry-standard encryption protocols</li>
                      <li><strong>Access Controls:</strong> Strict role-based access controls and multi-factor authentication for all administrative access</li>
                    </ul>
                    
                    <h3>2. On-Premises Security</h3>
                    <p>For on-premises deployments, Cybernate provides security guidelines and tools to help you maintain a secure environment. Our solutions can operate in air-gapped networks without external connectivity when required.</p>
                    
                    <h3>3. Security Compliance</h3>
                    <p>Cybernate maintains compliance with various security standards and regulations, including:</p>
                    <ul>
                      <li>ISO 27001 (Information Security Management)</li>
                      <li>SOC 2 Type II</li>
                      <li>GDPR compliance for EU customers</li>
                      <li>CCPA compliance for California customers</li>
                    </ul>
                    
                    <h3>4. Security Incident Response</h3>
                    <p>In the event of a security incident, Cybernate has an established response process that includes:</p>
                    <ul>
                      <li>Prompt identification and containment of the incident</li>
                      <li>Thorough investigation of the cause and impact</li>
                      <li>Timely notification to affected customers as required by law</li>
                      <li>Implementation of measures to prevent similar incidents</li>
                    </ul>
                    <p>We will notify affected customers within 72 hours of discovering a breach that impacts their data.</p>
                  </div>
                  
                  <div id="opt5" className="tab-pane fade">
                    <h2 className="font-gilroy-bold">API Usage Terms</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. API Access</h3>
                    <p>Cybernate provides API access to our Services to enable integration with your systems and applications. Your use of our APIs is subject to these terms in addition to the overall Terms of Service.</p>
                    
                    <h3>2. API Rate Limits</h3>
                    <p>To ensure service stability, Cybernate implements rate limits on API usage. These limits vary by subscription tier. If you exceed these limits, your requests may be throttled or rejected. Please contact us if you require higher limits.</p>
                    
                    <h3>3. API Keys and Authentication</h3>
                    <p>You are responsible for maintaining the security of your API keys and authentication credentials. Do not share your API keys publicly or with unauthorized parties. Cybernate is not responsible for any unauthorized access resulting from your failure to secure your API keys.</p>
                    
                    <h3>4. Prohibited API Uses</h3>
                    <p>When using Cybernate's APIs, you must not:</p>
                    <ul>
                      <li>Attempt to exceed or circumvent rate limits</li>
                      <li>Use the API in a manner that could damage, disable, or impair Cybernate's servers or networks</li>
                      <li>Use the API for any application that replicated or competes with Cybernate</li>
                      <li>Reverse engineer or attempt to extract the source code of our API or any related software</li>
                    </ul>
                    
                    <h3>5. API Changes and Deprecation</h3>
                    <p>Cybernate may modify or update the APIs from time to time. For significant changes that may affect your integration, we will provide advance notice through our developer portal and email communications. We maintain a deprecation policy that provides at least 6 months' notice before removing any API functionality.</p>
                  </div>
                  
                  <div id="opt6" className="tab-pane fade">
                    <h2 className="font-gilroy-bold">Compliance & Regulations</h2>
                    <div className="update-date">LAST UPDATED: MAY 15, 2025</div>
                    <h3>1. GDPR Compliance</h3>
                    <p>Cybernate has implemented various measures to comply with the General Data Protection Regulation (GDPR):</p>
                    <ul>
                      <li>We process personal data only on documented instructions from you, the data controller</li>
                      <li>We have implemented appropriate technical and organizational measures to ensure data security</li>
                      <li>We assist data controllers in fulfilling their obligations to respond to data subjects' requests</li>
                      <li>We provide mechanisms for data portability and deletion</li>
                    </ul>
                    
                    <h3>2. Regional Compliance</h3>
                    <p>Cybernate is committed to complying with applicable data protection laws in the regions where we operate, including:</p>
                    <ul>
                      <li>California Consumer Privacy Act (CCPA)</li>
                      <li>Brazilian General Data Protection Law (LGPD)</li>
                      <li>Australia's Privacy Act</li>
                      <li>Canada's Personal Information Protection and Electronic Documents Act (PIPEDA)</li>
                    </ul>
                    
                    <h3>3. Data Transfers</h3>
                    <p>For customers in regions with data localization requirements, Cybernate offers regional data storage options. When data must be transferred across borders, we use approved transfer mechanisms such as Standard Contractual Clauses.</p>
                    
                    <h3>4. Compliance Documentation</h3>
                    <p>Cybernate maintains documentation to demonstrate our compliance with applicable regulations. Upon request, we can provide:</p>
                    <ul>
                      <li>Data Processing Addendums (DPAs)</li>
                      <li>Security assessment reports</li>
                      <li>Compliance certifications</li>
                      <li>Documentation of technical and organizational measures</li>
                    </ul>
                    <p>To request compliance documentation, please contact our compliance team at <a href="mailto:support@cybernate.ai">support@cybernate.ai</a>.</p>
                  </div>
                </div> {/* /.tab-content */}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
        
        {/* Contact Modal */}
        <ContactModal />
        
        {/* Scroll Top Button */}
        <button className="scroll-top">
          <i className="fa fa-angle-up" aria-hidden="true" />
        </button>
      </div>
    </>
  );
}



export default Legal;